<template>
  <div class="mb-4">
    <v-card outlined>
      <v-card-title class="py-2 px-4 subtitle-2 grey lighten-4">
        {{ label }}
        <v-chip v-if="refName" x-small class="ml-2" color="purple lighten-4">$ref: {{ refName }}</v-chip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4">
        <schema-field
          :fields="schema"
          :value="value || {}"
          :root-value="rootValue"
          :locales="locales"
          :readonly="readonly"
          :entity-id="entityId"
          @input="$emit('input', $event)"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ObjectField',
  components: {
    SchemaField: () => import('../SchemaField.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: '',
    },
    schema: {
      type: [Object, Array],
      required: true,
    },
    refName: {
      type: String,
      default: null,
    },
    rootValue: {
      type: Object,
      required: true,
    },
    locales: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>
